
document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('toggleFiltro2');
    const menu = document.getElementById('menuFiltro2');
    const selected = document.getElementById('selectedOption2');
    let categoriaActiva = '0';
    let ordenActivo = 'desc';

    if(toggle){
        toggle.addEventListener('click', function (e) {
            e.stopPropagation();
            menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
        });
        document.getElementById('dropdownFiltro').addEventListener('click', function (e) {
            e.stopPropagation(); // Evita que se cierre al hacer clic dentro del dropdown
        });
    
        document.addEventListener('click', function (e) {    
            // Solo cerrar si el clic fue fuera del menú y fuera del toggle
            if (!menu.contains(e.target) && !toggle.contains(e.target)) {
                menu.style.display = 'none';
            }
        });
    }
    

    if(toggle){
        // Filtro por categoría (dropdown personalizado con radios)
        document.querySelectorAll('#menuFiltro2 input[type=radio]').forEach(input => {
            input.addEventListener('change', function () {
                categoriaActiva = this.value;
                selected.textContent = this.parentElement.textContent.trim();
                menu.style.display = 'none';
                filtrarEventos();
            });
        });
    }

    document.querySelectorAll('.orden-btn').forEach(btn => {
        btn.addEventListener('click', function () {
            document.querySelectorAll('.orden-btn').forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            ordenActivo = this.getAttribute('data-orden');
            filtrarEventos();
        });
    });


    function filtrarEventos(filtroCategoria = true) {
        const contenedor = document.getElementById('contenedor-items');
        let eventos = Array.from(document.querySelectorAll('.item-portfolio'));

        eventos.forEach(evento => {
            const cat = evento.dataset.categoria || '';
            const coincideCategoria = !filtroCategoria || categoriaActiva === "0" || cat === categoriaActiva;
            evento.style.display = coincideCategoria ? '' : 'none';
        });

        // Ordenar dinámicamente los visibles
        const eventosFiltrados = eventos.filter(e => e.style.display !== 'none');

        eventosFiltrados.sort((a, b) => {
            const fechaA = new Date(a.dataset.fechaFin);
            const fechaB = new Date(b.dataset.fechaFin);
            return ordenActivo === 'asc' ? fechaA - fechaB : fechaB - fechaA;
        });

        eventosFiltrados.forEach(item => contenedor.appendChild(item));
    }

});




